<template>
  <div
    class="full-screen-overlay d-flex justify-content-center align-items-center w-100 h-100 position-fixed top-0 start-0"
    :class="`${isFullScreen ? 'open' : 'closed'}`"
    style="background-color: rgba(13, 20, 27, 0.9); z-index: 2000"
    @click="toggleFullScreen()"
  >
  <FullScreenOverlayMobile
    v-if="isMobileView"
    :isFullScreen="isFullScreen"
    :allPrestationsImages=allPrestationsImages
    :currentIndex="currentIndex"
    :totalImages="totalImages"
    @toggleFullScreen="toggleFullScreen"
    @updateIndex="updateIndex"
  />

  <FullScreenOverlayDesktop
    v-else
    :image="image"
    :currentIndex="currentIndex"
    :totalImages="totalImages"
    :currentSectionName="currentSectionName"
    @toggleFullScreen="toggleFullScreen"
    @updateIndex="updateIndex"
  />
  </div>
</template>

<script>
import { isMobile } from '@/utils/utils';
import FullScreenOverlayDesktop from './FullScreenOverlayDesktop.vue';
import FullScreenOverlayMobile from './FullScreenOverlayMobile.vue';

export default {
  components: {
    FullScreenOverlayDesktop,
    FullScreenOverlayMobile
},
  props: {
    image: Object,
    currentIndex: Number,
    totalImages: Number,
    currentSectionName: String,
    isFullScreen: Boolean,
    allPrestationsImages: Array
  },
  data() {
    return {
      isMobileView: isMobile(),
    };
  },
  methods: {
    toggleFullScreen(value) {
      this.$emit("toggleFullScreen", value);
    },
    updateIndex(index) {
      this.$emit("updateIndex", index);
    },
  },
};
</script>

<style scoped>
.full-screen-overlay {
  align-items: center;
  padding: 20px 0;
  transition: all .3s;
}

@media (min-width: 768px) {
  .full-screen-overlay.open {
    display: block
  }

  .full-screen-overlay.closed {
    display: none !important
  }
}

@media (max-width: 768px) {
  .full-screen-overlay {
    align-items: center;
    padding: 20px 0;
  }
  .full-screen-overlay.open {
    transform: translateY(0);
  }

  .full-screen-overlay.closed {
    transform: translateY(1000px);
  }
}
</style>